module.exports = __webpack_public_path__ + "img/login.6e5a60b9.jpg";